<template>
  <div class="v3-popup bag-popup score-detail-popup">
    <div class="v3-popup-mask" @click="handleClose"></div>
    <div class="v3-popup-content large">
      <div class="v3-popup-content-close" @click="handleClose"></div>
      <div class="v3-popup-content-title"></div>
      <div class="v3-popup-content-content">
        <table>
          <thead>
            <tr>
              <th>獎品名稱</th>
              <th>獎品數量</th>
              <th>獲得時間</th>
              <th>當前狀態</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in awardLogList" :key="index">
              <td>{{ awardConfig[item.AWARD_ID] }}</td>
              <td>{{ item.AWARD_NUM }}</td>
              <td>{{ item.CREATE_TIME }}</td>
              <td>{{ awardState(item.AWARD_STATE) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="v3-popup-content-footer">
        <div
          class="page-pre"
          :class="{ un: page <= 1 }"
          @click="handlePrevPage"
        ></div>
        <template v-for="(pageNum, index) in displayPages" :key="index">
          <div v-if="pageNum === '...'" class="page-num">...</div>
          <div
            v-else
            class="page-num"
            :class="{ active: pageNum === page }"
            @click="handlePageClick(pageNum)"
          >
            {{ pageNum }}
          </div>
        </template>
        <div
          class="page-next"
          :class="{ un: page >= totalPages }"
          @click="handleNextPage"
        ></div>
      </div>
      <p class="bag-popup-tips">* 請在遊戲公測期間前往該頁面領取</p>
    </div>
  </div>
</template>

<script setup>
import { inject, reactive, ref, watch, computed } from "vue";
import { getActivityApi, getJSON } from "@utils";
import { awardConfig } from "@/config";

const showCurErrorTips = inject("showCurErrorTips", () => {});
const v3PopupState = inject("v3PopupState", reactive({}));

// 定义 props
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
});

const page = ref(1);
const awardLogList = ref([]);
const total = ref(0);
const pageSize = 6;

// 计算总页数
const totalPages = computed(() => {
  return Math.ceil(total.value / pageSize) || 1;
});

// 计算要显示的页码
const displayPages = computed(() => {
  const pages = [];
  const total = totalPages.value;

  if (total <= 5) {
    // 总页数不超过7页，全部显示
    for (let i = 1; i <= total; i++) {
      pages.push(i);
    }
  } else {
    // 总页数超过7页，显示前4页+省略号+后3页
    for (let i = 1; i <= 2; i++) {
      pages.push(i);
    }
    pages.push("...");
    for (let i = total - 2; i <= total; i++) {
      pages.push(i);
    }
  }

  return pages;
});

// 关闭弹窗
const handleClose = () => {
  v3PopupState.bagPopupState = false;
};

const awardState = computed(() => {
  return (state) => {
    return state == 1 ? "未領取" : "已領取";
  };
});

const excGetList = async () => {
  let res = await getJSON(
    getActivityApi(window.platform_id, window.activity_name, "myAward"),
    {
      params: JSON.stringify({
        page: page.value,
        pageSize: pageSize,
      }),
    }
  );
  // let res = {
  //   code: 1,
  //   result: 1,
  //   msg: "success",
  //   data: {
  //     awardData: [
  //       {
  //         ID: "1",
  //         ACTIVITY_ID: "3422",
  //         LOGIN_ACCOUNT: "GOGL:1235190827",
  //         SID: "0",
  //         ROLE_ID: "",
  //         AWARD_TYPE: "lottery",
  //         AWARD_ID: "Title", // 奖品id
  //         AWARD_VT_TYPE: "sendVt", // 奖励类型: sendVt发道具奖励,sendMaterial发实物奖励
  //         AWARD_VT_ID: "",
  //         AWARD_VALUE: null,
  //         AWARD_NUM: "1", // 奖励数量
  //         AWARD_STATE: "2", // 领取状态: 1未领取 2已领取
  //         CREATE_TIME: "2025-10-10 12:09:41",
  //         UPDATE_TIME: "2025-10-10 12:09:41",
  //         AWARD_TIME: "2025-10-10 12:09:41", // 领奖时间
  //       },
  //       {
  //         ID: "1",
  //         ACTIVITY_ID: "3422",
  //         LOGIN_ACCOUNT: "GOGL:1235190827",
  //         SID: "0",
  //         ROLE_ID: "",
  //         AWARD_TYPE: "lottery",
  //         AWARD_ID: "Title", // 奖品id
  //         AWARD_VT_TYPE: "sendVt", // 奖励类型: sendVt发道具奖励,sendMaterial发实物奖励
  //         AWARD_VT_ID: "",
  //         AWARD_VALUE: null,
  //         AWARD_NUM: "1", // 奖励数量
  //         AWARD_STATE: "2", // 领取状态: 1未领取 2已领取
  //         CREATE_TIME: "2025-10-10 12:09:41",
  //         UPDATE_TIME: "2025-10-10 12:09:41",
  //         AWARD_TIME: "2025-10-10 12:09:41", // 领奖时间
  //       },
  //       {
  //         ID: "1",
  //         ACTIVITY_ID: "3422",
  //         LOGIN_ACCOUNT: "GOGL:1235190827",
  //         SID: "0",
  //         ROLE_ID: "",
  //         AWARD_TYPE: "lottery",
  //         AWARD_ID: "Title", // 奖品id
  //         AWARD_VT_TYPE: "sendVt", // 奖励类型: sendVt发道具奖励,sendMaterial发实物奖励
  //         AWARD_VT_ID: "",
  //         AWARD_VALUE: null,
  //         AWARD_NUM: "1", // 奖励数量
  //         AWARD_STATE: "2", // 领取状态: 1未领取 2已领取
  //         CREATE_TIME: "2025-10-10 12:09:41",
  //         UPDATE_TIME: "2025-10-10 12:09:41",
  //         AWARD_TIME: "2025-10-10 12:09:41", // 领奖时间
  //       },
  //       {
  //         ID: "1",
  //         ACTIVITY_ID: "3422",
  //         LOGIN_ACCOUNT: "GOGL:1235190827",
  //         SID: "0",
  //         ROLE_ID: "",
  //         AWARD_TYPE: "lottery",
  //         AWARD_ID: "Title", // 奖品id
  //         AWARD_VT_TYPE: "sendVt", // 奖励类型: sendVt发道具奖励,sendMaterial发实物奖励
  //         AWARD_VT_ID: "",
  //         AWARD_VALUE: null,
  //         AWARD_NUM: "1", // 奖励数量
  //         AWARD_STATE: "2", // 领取状态: 1未领取 2已领取
  //         CREATE_TIME: "2025-10-10 12:09:41",
  //         UPDATE_TIME: "2025-10-10 12:09:41",
  //         AWARD_TIME: "2025-10-10 12:09:41", // 领奖时间
  //       },
  //       {
  //         ID: "1",
  //         ACTIVITY_ID: "3422",
  //         LOGIN_ACCOUNT: "GOGL:1235190827",
  //         SID: "0",
  //         ROLE_ID: "",
  //         AWARD_TYPE: "lottery",
  //         AWARD_ID: "Title", // 奖品id
  //         AWARD_VT_TYPE: "sendVt", // 奖励类型: sendVt发道具奖励,sendMaterial发实物奖励
  //         AWARD_VT_ID: "",
  //         AWARD_VALUE: null,
  //         AWARD_NUM: "1", // 奖励数量
  //         AWARD_STATE: "2", // 领取状态: 1未领取 2已领取
  //         CREATE_TIME: "2025-10-10 12:09:41",
  //         UPDATE_TIME: "2025-10-10 12:09:41",
  //         AWARD_TIME: "2025-10-10 12:09:41", // 领奖时间
  //       },
  //     ],
  //     total: 6, // 总条数
  //     materialCanClaim: false, // 实物发奖是否能领取
  //     vtCanClaim: false, // 虚拟发奖是否能领取
  //   },
  // };

  if (res.result != 1) {
    showCurErrorTips(res.code);
    return;
  }

  awardLogList.value = res.data.awardData || [];
  total.value = res.data.total || 0;
};

const switchPage = (pageNum) => {
  page.value = pageNum;
  excGetList();
};

// 上一页
const handlePrevPage = () => {
  if (page.value > 1) {
    switchPage(page.value - 1);
  }
};

// 下一页
const handleNextPage = () => {
  if (page.value < totalPages.value) {
    switchPage(page.value + 1);
  }
};

// 点击页码
const handlePageClick = (pageNum) => {
  if (pageNum !== page.value) {
    switchPage(pageNum);
  }
};

const init = async () => {
  awardLogList.value = [];
  page.value = 1;
  await excGetList();
};

watch(
  () => v3PopupState.bagPopupState,
  (value) => {
    if (value) {
      init();
    } else {
      awardLogList.value = [];
      page.value = 1;
    }
  }
);
</script>

<style scoped lang="less"></style>
